import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentGql } from './DatasourcesDisplayGridRowDataFragmentGql';

export const DatasourceUpstreamDatasourcesQueryGql: DocumentNode = gql`
query DatasourceUpstreamDatasourcesQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragment
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentGql}
`;
